import monochromeSpriteURL from '@dist/svg-sprite/monochrome.sprite.svg';
import multicolorSpriteURL from '@dist/svg-sprite/multicolor.sprite.svg';
import productIconsSpriteURL from '@dist/svg-sprite/product-icons.sprite.svg';
import webIconsSpriteURL from '@dist/svg-sprite/web.sprite.svg';
import { Logger } from '@utils/logger';
import { createApp } from './main';

const injectSprite = async (id, path) => {
    try {
        const resp = await fetch(path);
        const svg = await resp.text();

        const div = document.createElement('div');
        div.id = id;
        div.innerHTML = svg;
        div.style.cssText = 'position: absolute; width: 0; height: 0; overflow: hidden;';
        div.classList.add('hidden');
        document.body.insertBefore(div, document.body.childNodes[0]);
    } catch (error) {
        Logger.error({ error });
    }
};

async function main() {
    await Promise.all([
        injectSprite('product-icons', productIconsSpriteURL),
        injectSprite('web-icons', webIconsSpriteURL),
        injectSprite('monochrome-icons', monochromeSpriteURL),
        injectSprite('multicolor-icons', multicolorSpriteURL),
    ]);

    const parseJSONScript = (id) => JSON.parse(document.getElementById(id)?.textContent || '{}');
    const initialState = parseJSONScript('app-state');
    const context = initialState.context;

    const { app, router, store } = createApp(context); // pass initialState.context

    store.replaceState(initialState);

    await router.isReady();
    app.mount('#app', true);
}

main();
